
import * as Components from "./Sushiyu"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "sushiyu"
}

